// Generated by CoffeeScript 1.12.7
(function() {
  var g;

  g = typeof window !== "undefined" && window !== null ? window : typeof self !== "undefined" && self !== null ? self : global;

  g.global = g;

}).call(this);
